import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VideoLibraryService } from '../../video-library.service';
import { Subscription } from 'rxjs';
import { Router, Event, NavigationEnd } from '@angular/router';
import { MultiFacilityService } from '../../../services/multi-facility.service';
import { MultiFacilityModel } from '../../../services/multi-facility.model';
import { HaloModalService } from 'src/app/core/halo-modal/halo-modal.service';
import { HaloModalSize } from 'src/app/core/halo-modal/halo-modal-interface';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { CustomizeBrandingService } from '../customize-branding.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { Customization, ImageSize } from '../../video-library.model';
@Component({
  selector: 'app-add-logo',
  templateUrl: './add-logo.component.html',
  styleUrls: ['./add-logo.component.scss'],
})
export class AddLogoComponent implements OnInit {
  @ViewChild('titleTemplate') titleTemplate: TemplateRef<any>;
  @ViewChild('action') action: TemplateRef<any>;
  @ViewChild('facilitiesTemplate') facilitiesTemplate: TemplateRef<any>;
  selectedFile: File | undefined;
  maxFileSize = 1024000 * 10; // 10MB.
  multiFacilities: MultiFacilityModel[];
  selectedFacilities: string[] = [];
  isPublishModal = false;
  isDeleteModal = false;
  showDeleteConfirmationModal = false;
  isEnabled = false;
  hasFullPermission = false;
  isNonClickedOnDeleteButton = true;
  currentUrl: string;
  selectedSingleSiteFacility: string;
  private sub = new Subscription();
  rootScopeData: RootScopeDeclare;
  logoSrc: any;
  environment = environment;
  validationError: string | undefined;
  customizeData: Customization | any = {};
  fileName: string | undefined;
  deleteFacilityPopupProperties = {
    title: 'DELETE.LOGO',
    message: 'DELETE.LOGO.CONFIRMATION',
    isWarningPopup: true,
    ctaButtonLabel: 'DELETE',
    negativeButtonLabel: 'CANCEL',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
  };
  facilitiesConsoleEquipmentsMap : any;
  facilityIds = [] as any;
  enabledEquipmentOnDemandNCustomLibrary = [] as any;
  zendeskUrl: string;
  logoHeight = '';
  constructor(
    private _vdoLibraryService: VideoLibraryService,
    private _modal: HaloModalService,
    private _router: Router,
    private _facilityService: FacilityService,
    private _commonUtil: CommonUtil,
    private _customizeBrandingService: CustomizeBrandingService,
    private _multiFacilityService: MultiFacilityService,
    private _loader: HaloLoaderService,
    private rootScopeService: RootScopeService,
    private _toast: HaloToastService
  ) {
    const routerSub = this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this._multiFacilityService.isMultifacilityUrl(event.url)) {
          this.currentUrl = event.url;
        }
      }
    });
    this.sub.add(routerSub);
  }

  async ngOnInit() {
    this.getRootScopeData(); 
    const dataSub = this._customizeBrandingService.customizeDataSubscriber.subscribe(data => {   
      this.selectedFile = undefined;
      this.fileName = undefined;
      this.logoSrc = '';
      if(data) {
        this.validationError = '';
        if(data.data[0]) {
          this.customizeData = data.data[0].attributes;
        } else {
          this.customizeData = {};
        }
        const logoImg = this._vdoLibraryService.getAvailableImageFormat(this.customizeData?.logo, ImageSize.THUMBNAIL);
        this.logoHeight = (Number(logoImg?.height) * 0.4) + 'px';
        this.logoSrc = logoImg?.url;
        this.fileName = logoImg?.name;
      }
    });
    this.sub.add(dataSub);

    const lfAssetApiResp = await this._facilityService.get();
    if(lfAssetApiResp){
      this.facilitiesConsoleEquipmentsMap = lfAssetApiResp.facilities;
    }

    this.zendeskUrl = 'https://lifefitness9512.zendesk.com/hc/en-us/articles/6916437634199';
  }

  getRootScopeData(): void {
    const getRpptScopeSub = this.rootScopeService
      .getRootScope()
      .subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
    this.sub.add(getRpptScopeSub);
  }

  fileBrowseHandler(files: any) {
    if (files) {
      this.validationError = this.validateSelectedFile(files[0]);
      if (this.validationError) return;
      var reader = new FileReader();
      reader.onload = (event: any) => {
        var image = new Image();
        image.src = event.target.result;
        image.onload = () => {
          let height = 120;
          let width = 250;
          let allowance = 0.15; // 15%
          if (image.naturalHeight <= height + (height*allowance) && image.naturalWidth <= width + (width*allowance)) {
            this.logoSrc = event.target.result;
            this.selectedFile = files[0];
            this.fileName = this.selectedFile?.name;
            this.logoHeight = image.naturalHeight * 0.4 + 'px';
          } else {
            this.validationError = this._commonUtil.translateText('IMAGE.DIMENSION.ERROR.MSG');
          }
        };
      };
      this.rootScopeData.isPageHasUnsavedChanges = true;
      reader.readAsDataURL(files[0]);
    } else {
      this.selectedFile = undefined;
      this.fileName = undefined;
      this.logoSrc = '';
    }
  }

  validateSelectedFile(file: File) {
    let error: string | undefined;
    var extensions = /(\.png|\.jpg|\.jpeg)$/i;
    // Check format. png or jpeg && // Check fileSize. Max 5GB
    if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') ||
      !extensions.exec(file.name)) {
      error = this._commonUtil.translateText('FILE.UPLOAD.FORMAT');
    }

    return error;
  }

  onDeleteFile() {
    if(this.customizeData?.logo?.data){
      if (this.isNonClickedOnDeleteButton) {
        this.isDeleteModal = true;
        this.isPublishModal = false;
        this.showLFODVideoTree();
        this.isNonClickedOnDeleteButton = false;
      }
    } else {
      this.selectedFile = undefined;
      this.fileName = undefined;
      this.logoSrc = '';      
      this.rootScopeData.isPageHasUnsavedChanges = false;
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  redirectVideoLibUpload() {
    this._router.navigate(['/videoLibrary']);
  }

  cancel(): void {
    this.isDeleteModal = false;
    this.isPublishModal = false;
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this._router.navigate(['/videoLibrary']);
  }

  next(): void {
    if (!this.isPublishModal) {
      this.isPublishModal = true;
      this.isDeleteModal = false;
      this.showLFODVideoTree();
    }
  }

  cancelOnModal(): void {
    this._modal.close();
    this.isPublishModal = false;
    this.isDeleteModal = false;
    this.isNonClickedOnDeleteButton = true;
  }

  async confirmOnModal(type: string) {
    if (type === 'publish' && this.selectedFile) {
      const formData = new FormData();
      const data = JSON.stringify({
        updatedBy: this.rootScopeData?.currentUser?.displayName,
        facilityIds: this.selectedFacilities.map((id) => +id),
      });
      formData.append('data', data);
      formData.append('files.logo', this.selectedFile);
      this._loader.startProcess();
      try {
        await this._customizeBrandingService.saveCustomize(formData);        
        this.validationError = '';
        this.selectedFile = undefined;        
        this.showDeleteConfirmationModal = false;
        this.isNonClickedOnDeleteButton = true;
        this._toast.creatToast(this._commonUtil.translateText('PUBLISHED.LOGO'));
        this.rootScopeData.isPageHasUnsavedChanges = false;
      } catch (error) {
        console.log('API failed.');
      }
      this.cancelOnModal();
      this._loader.endProcess();
    } else {
      this.deleteModalConfirm();
    }
  }

  async deleteModalConfirm() {
    const list = this.selectedFacilities.map((id) => +id);    
    let deteledFac = list.length > 1 ? list.length.toString() : this._facilityService.getFacilityById(list[0].toString())?.facilityName;    
    this.showDeleteConfirmationModal = false;
    this._loader.startProcess();
    try {
      await this._customizeBrandingService.saveCustomize({logo: null, facilityIds: list});
      this.selectedFile = undefined;
        this.fileName = undefined;
        this.logoSrc = '';
        this._loader.endProcess();
        let toastMsgId = '';
        this.isNonClickedOnDeleteButton = true;
        if(list.length > 1) toastMsgId = "DELETE.LOGO.SUCCESS.MSG";
        else  toastMsgId = "DELETE.LOGO.SUCCESS.MSG2";
        this._toast.creatToast(
          this._commonUtil.replaceValueAsHTMLOnTranslatedText(toastMsgId, [deteledFac??''])
        );
        this.rootScopeData.isPageHasUnsavedChanges = false;
    } catch (error) {        
      console.error('API error.');
    }
    this.cancelOnModal();
    this._loader.endProcess();
  }

  onSelectedFacilityChanged(value: any): void {
    let fac = value.map((val:any) => val.facilityId);
    this.isEnabled = fac.length > 0;
    this.selectedFacilities = fac;
  }

  async showLFODVideoTree() {
    this._loader.startProcess();
    try {
      let respMultiFacilities = await this._multiFacilityService.getMultiFacilities();
      if(this.isDeleteModal && respMultiFacilities?.length === 1 && !respMultiFacilities[0]?.children?.length) {
        this.selectedFacilities = [this._facilityService.selectedFacility().facilityId];
        this.showDeleteConfirmationModal = true;
      } else {
        let defaultFacilities:any;
        respMultiFacilities = this.filter(JSON.parse(JSON.stringify(respMultiFacilities)));
        defaultFacilities = this.selectDefault(respMultiFacilities);


        /* Start Here , Below code make facility check option to be disiabled based on the isLFODEnabledCount */
        this.facilityIds = [];
        let data = [] as any;
        this.getFacilityIds(defaultFacilities);     
        let tmp_1 = await this._vdoLibraryService.getEnabledOnDemandClasses(this.facilityIds).toPromise();
        let tmp_2 =  Object.entries(tmp_1) as any;
        let se4ConsolesTypes = ['hal','everest','neo_se4','falco'];
        tmp_2.forEach((ele:any) => {
          if(JSON.stringify(ele) !== "{}"){
            let eqStatus = Object.values(ele[1]) as any;      
            let obj = {
              "facilityId": ele[0],
              "isLFODEnabledCount": eqStatus.find((val:any) => val.lfodenabledCount>0)?true:false,
              "isSe4LFODEnabledCount": eqStatus.find((val:any) => se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false,
              "isSe3LFODEnabledCount": eqStatus.find((val:any) => !se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false,
              "isCustomLibraryEnabledCount" : eqStatus.find((val:any) => val.customLibraryEnabledCount>0)?true:false
            }   
            data.push(obj);
          }
        });

        this.enabledEquipmentOnDemandNCustomLibrary = data;
        this.multiFacilities = this.updateIsEnabledStatus(defaultFacilities);
        /* End Here */

        this._modal.add({
          dismissible: true,
          titleUppercase: true,
          modalSize: HaloModalSize.Medium,
          titleTemplate: this.titleTemplate,
          footerTemplate: this.action,
          bodyTemplate: this.facilitiesTemplate,
          isVideoTree: false,
        });
      }
    } catch (error) {
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  updateIsEnabledStatus(facilities: MultiFacilityModel[]) {
    facilities?.forEach((facility) => {
      let fac = this.facilitiesConsoleEquipmentsMap.find((fConsole : any) => fConsole.facilityId === facility.facilityId);
      let tmp = this.enabledEquipmentOnDemandNCustomLibrary.find((val:any) => val.facilityId === facility.facilityId);
      if(fac.summary.userRights.customLibrary === "F"){
        if(tmp && tmp.facilityId){
          if(tmp.isLFODEnabledCount === true){
            facility.isEnabled = true;
          }else{
            facility.isEnabled = false;
          }
        }
      }else{
        facility.isEnabled = false;
      }      
      this.updateIsEnabledStatus(facility.children);
    });
    return facilities;
  }

  getFacilityIds(facilities: MultiFacilityModel[]) {
    facilities?.forEach((fac) => {
      this.facilityIds.push(Number(fac.facilityId));
      this.getFacilityIds(fac.children);
    });
    return facilities;
  }

  filter(facilities: MultiFacilityModel[]) {
    let filteredFacs: MultiFacilityModel[] = [];
    facilities?.forEach((facility) => {
      facility.children = this.filter(facility.children);
      facility.isEnabled = this.isValidLFODSupportFacility(facility);
      if (facility.isEnabled || this.hasLFODEnabledChildren(facility)) {
        filteredFacs.push(facility);
      }
    });
    return filteredFacs;
  }

  hasLFODEnabledChildren(facModel: MultiFacilityModel) {
    if (!facModel || !facModel.children) return false;
    for (let child of facModel.children) {
      if (child?.isEnabled || this.hasLFODEnabledChildren(child)) return true;
    }
    return false;
  }

  isValidLFODSupportFacility(facilityData: MultiFacilityModel) {
    return facilityData
      ? this._multiFacilityService.isMultifacilitySupported(this.currentUrl ?? this._router.url, facilityData)
      : false;
  }

  selectDefault(facilities: MultiFacilityModel[]) {
    facilities?.forEach((facility) => {
      let selectedFacility = this._facilityService.selectedMultiFacilities();
      let isValidLFODSup = this.isValidLFODSupportFacility(facility);
      if (selectedFacility.findIndex((f) => f === facility.facilityId) > -1 && isValidLFODSup) {
        facility.isSelected = true;
        facility.isDisabledSelectedFacility = true;
        this.selectedSingleSiteFacility = facility.facilityId;
      } else {
        facility.isSelected = false;
        facility.isDisabledSelectedFacility = false;
      }
      let fac = this.facilitiesConsoleEquipmentsMap.find((fConsole : any) => fConsole.facilityId === facility.facilityId);
      if(fac.summary.userRights.customLibrary !== "F"){
        facility.isEnabled = false;
      }
      this.selectDefault(facility.children);
    });
    return facilities;
  }

  onPermissionChange(value:boolean){
    this.hasFullPermission = value;
  }
}
